require('./highlighted.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    Component
} = require('react');

class Highlighted extends Component {
    render() {
        const { children, isHighlighted } = this.props;
        let highlightedElement = null;

        if (typeof children !== 'string' || children.trim()){
            highlightedElement = (
                <span className={isHighlighted ? 'highlighted' : ''}>
                    {children}
                </span>
            );
        }

        return highlightedElement;
    }
}

Highlighted.propTypes = {
    children: PropTypes.any.isRequired,
    isHighlighted: PropTypes.bool
};

Highlighted.defaultProps = {
    isHighlighted: true
}

module.exports = Highlighted;